module.exports = __webpack_public_path__ + "img/p-icon2.ee00ff7b.png";